import { render, staticRenderFns } from "./navFooter.vue?vue&type=template&id=58d678c8&scoped=true&"
import script from "./navFooter.vue?vue&type=script&lang=js&"
export * from "./navFooter.vue?vue&type=script&lang=js&"
import style0 from "./navFooter.vue?vue&type=style&index=0&id=58d678c8&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58d678c8",
  null
  
)

export default component.exports